import React from 'react';
import { Skeleton } from '@mui/material';

const DEFAULT_COLUMNS = ['Column', 'Type', 'Primary'];

export interface TableColumnsSkeletonProps {
  columns?: string[];
  rowsCount?: number;
}

export function TableColumnsSkeleton({
  columns = DEFAULT_COLUMNS,
  rowsCount = 5,
}: TableColumnsSkeletonProps) {
  return (
    <table className="columns-table">
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col} className="columns-table-col-15">
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rowsCount }).map((_, ix) => (
          <tr key={`skeleton-${ix}`}>
            {columns.map((col) => (
              <td key={col} className="columns-table-col-15">
                <Skeleton variant="text" width="80%" height={30} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

TableColumnsSkeleton.displayName = 'TableColumnsSkeleton';
